// extracted by mini-css-extract-plugin
export default {"wrapper":"ArticleHome_wrapper__s7igD"};